export const standardTransition = (value, duration = '0.2s') => {
  return `${value} ${duration} linear`;
};
